import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offshore-dev',
  templateUrl: './offshore-dev.component.html',
  styleUrls: ['./offshore-dev.component.css']
})
export class OffshoreDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/offshore-dev/offshore-dev.component.ts